import { createSlotsContext } from "@grandvisionhq/slots";
const [CartSlotsProvider, useCartSlots] = createSlotsContext({
  displayName: "CartSlotsContext"
});
export {
  CartSlotsProvider,
  useCartSlots
};
//# sourceMappingURL=context.js.map
